import { Star } from "lucide-react";

type Review = {
  author: string;
  date: string;
  dateLabel: string;
  rating: number;
  text: string;
};

const reviews: Review[] = [
  {
    author: "Marco Maria",
    date: "2026-02-25",
    dateLabel: "Febbraio 2026",
    rating: 5,
    text: "Ottimo ristorante a Passignano. Posto bello curato nei particolari, pulito ordinato, bagno sempre pulito. Pinsa squisita, fritto ottimo. Scelta di vini di qualità, ottime le birre. Servizio al tavolo premuroso educato sempre disponibile. Bello e buono.",
  },
  {
    author: "Sara Perugini",
    date: "2026-01-25",
    dateLabel: "Gennaio 2026",
    rating: 5,
    text: "Questa estate avevo fatto una piacevole cena in terrazza, siamo tornati oggi ed anche il locale sotto è veramente bello ed accogliente. Cibo ottimo e personale carinissimo.",
  },
  {
    author: "Nadia Copta",
    date: "2025-12-25",
    dateLabel: "Dicembre 2025",
    rating: 5,
    text: "Sono rimasta molto colpita dalla dolcezza e dall'eleganza che si respirano in questo ristorante. Le ragazze che mi hanno servita sono state tutte molto carine, gentili e curate. Ho mangiato molto bene: i piatti erano ottimi e ben presentati. Il locale all'interno è molto bello e trasmette un'atmosfera calda e accogliente.",
  },
  {
    author: "Amedeo Scrosati",
    date: "2025-08-25",
    dateLabel: "Agosto 2025",
    rating: 5,
    text: "Locale situato fronte lago, con una vista piacevole e rilassante, presenti posti sia all'aperto sia al chiuso. Ho iniziato con un fritto di pesce davvero buono: ricco, saporito e accompagnato anche da verdure fritte. Come dolce, ho scelto un gelato al limone, semplice ma sorprendentemente gustoso. Posto consigliato, se dovessi tornare in zona ci farò sicuramente un'altra visita!",
  },
  {
    author: "Moreno Corio",
    date: "2025-08-25",
    dateLabel: "Agosto 2025",
    rating: 4,
    text: "Ristorante vista lago con arredamento abbastanza curato. Cibo di buon livello, tagliere umbro buonissimo così come gli gnocchi. Sebbene non segnalato in menù, sono presenti proposte senza glutine, compresa la pasta. Tutti i piatti assaggiati erano buoni.",
  },
];

const StarRating = ({ rating }: { rating: number }) => (
  <div className="flex gap-0.5" aria-label={`${rating} stelle su 5`}>
    {[1, 2, 3, 4, 5].map((star) => (
      <Star
        key={star}
        size={18}
        className={
          star <= rating
            ? "fill-gold text-gold"
            : "fill-muted text-muted-foreground/30"
        }
      />
    ))}
  </div>
);

const RecensioniSection = () => {
  return (
    <section id="recensioni" className="section-padding bg-gradient-subtle">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="text-section-title text-primary mb-4">
            Cosa Dicono <span className="text-gold">i Nostri Clienti</span>
          </h2>
          <div className="flex items-center justify-center gap-2 mb-4">
            <StarRating rating={5} />
            <span className="text-lg font-semibold text-primary">4.8 / 5</span>
            <span className="text-sm text-muted-foreground">
              su oltre 150 recensioni Google
            </span>
          </div>
          <p className="text-body-large text-muted-foreground max-w-2xl mx-auto font-serif">
            Recensioni autentiche dei nostri ospiti raccolte su Google.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {reviews.map((review, index) => (
            <article
              key={index}
              className="bg-background rounded-2xl shadow-elegant p-6 flex flex-col"
            >
              <div className="flex items-center justify-between mb-3">
                <StarRating rating={review.rating} />
                <time
                  dateTime={review.date}
                  className="text-xs text-muted-foreground"
                >
                  {review.dateLabel}
                </time>
              </div>
              <blockquote className="text-sm text-muted-foreground font-serif leading-relaxed flex-1 mb-4">
                "{review.text}"
              </blockquote>
              <footer className="flex items-center justify-between pt-4 border-t border-border">
                <cite className="text-sm font-semibold text-primary not-italic">
                  {review.author}
                </cite>
                <span className="text-xs text-muted-foreground">via Google</span>
              </footer>
            </article>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://www.google.com/maps/search/?api=1&query=Ristorante+Da+Armando+Passignano+sul+Trasimeno"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-gold hover:text-gold-hover font-medium transition-colors"
          >
            Leggi tutte le recensioni su Google
            <span aria-hidden="true">→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default RecensioniSection;
